/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockInformation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 10h-2V4H4v16h6v2H2V2h18z" />
        <path d="M18 14a4 4 0 1 1-.002 8.002A4 4 0 0 1 18 14zm-.5 2v2.208l1.147 1.145.706-.706-.853-.854V16zM8 13H6v-2h2zm6 0h-4v-2h4zM8 9H6V7h2zm8 0h-6V7h6z" />
      </g>
    </g>
  </Icon>
);
export { SvgClockInformation as ClockInformation };
